const RELOAD_KEY = 'chunkLoadReloadAt';
const RELOAD_GUARD_MS = 60_000;

/** True for the errors browsers raise when a lazy chunk of an older deployment no longer exists on the server. */
export function isChunkLoadError(reason: unknown): boolean {
  const message = reason instanceof Error ? reason.message : typeof reason === 'string' ? reason : '';
  return /error loading dynamically imported module|Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError/i.test(message);
}

/**
 * After a release the file names of the lazy chunks change. A tab that still runs the old index.html then fails
 * to load them (and Ionic components such as ion-toast are missing). One reload fetches the current index.html;
 * the guard prevents a reload loop when the chunk is really missing.
 */
export function installChunkLoadRecovery(win: Window = window): void {
  const recover = (reason: unknown): void => {
    if (!isChunkLoadError(reason)) return;
    try {
      const last = Number(win.sessionStorage.getItem(RELOAD_KEY) ?? 0);
      if (Date.now() - last < RELOAD_GUARD_MS) return;
      win.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
      return;
    }
    win.location.reload();
  };

  win.addEventListener('unhandledrejection', (e) => recover(e.reason));
  win.addEventListener('error', (e) => recover(e.error ?? e.message));
}
